<button
  type="button"
  class="bell-button"
  (click)="toggle($event)"
  [attr.aria-label]="bellLabel"
  [title]="t.BELL_LABEL"
  [attr.aria-expanded]="open"
  aria-haspopup="dialog"
>
  <i class="bi bi-bell" aria-hidden="true"></i>
  @if (unreadCount > 0) {
    <span class="bell-badge" aria-hidden="true">{{ badgeText }}</span>
  }
</button>

<p-popover #popover styleClass="notification-popover" [ariaLabel]="t.PANEL_TITLE" (onShow)="onShow()" (onHide)="onHide()">
  <div class="np-panel">
    <div class="np-header">
      <h2 class="np-title">{{ t.PANEL_TITLE }}</h2>
      <button type="button" class="np-mark-all" [disabled]="unreadCount === 0" (click)="markAllRead()">
        {{ t.MARK_ALL_READ }}
      </button>
    </div>

    @if (state === 'loading' && notifications.length === 0) {
      <div class="np-state" role="status">
        <i class="bi bi-hourglass-split" aria-hidden="true"></i>
        <p>{{ t.LOADING }}</p>
      </div>
    } @else if (state === 'error' && notifications.length === 0) {
      <div class="np-state np-state--error" role="alert">
        <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
        <p>{{ t.LOAD_ERROR }}</p>
        <button type="button" class="np-retry" (click)="load()">{{ t.RETRY }}</button>
      </div>
    } @else if (notifications.length === 0) {
      <div class="np-state">
        <i class="bi bi-bell-slash" aria-hidden="true"></i>
        <p class="np-empty-title">{{ t.EMPTY_TITLE }}</p>
        <p class="np-empty-description">{{ t.EMPTY_DESCRIPTION }}</p>
      </div>
    } @else {
      <ul class="np-list">
        @for (notification of notifications; track notification.id) {
          <li>
            <button
              type="button"
              class="np-item"
              [class.np-item--unread]="!notification.read_at"
              [title]="t.OPEN_OFFER"
              (click)="onItemClick(notification)"
            >
              <span class="np-dot" [class.np-dot--on]="!notification.read_at" aria-hidden="true"></span>
              <span class="np-body">
                <span class="np-job-title">{{ titleOf(notification) }}</span>
                @if (metaOf(notification)) {
                  <span class="np-job-meta">{{ metaOf(notification) }}</span>
                }
                <span class="np-tags">
                  @if (notification.payload.is_remote) {
                    <span class="np-tag np-tag--remote">{{ t.REMOTE }}</span>
                  }
                  @if (matchLabel(notification); as label) {
                    <span class="np-tag np-tag--match">{{ label }}</span>
                  }
                  <span class="np-time">{{ timeAgo(notification) }}</span>
                </span>
              </span>
              @if (!notification.read_at) {
                <span class="np-sr-only">{{ t.UNREAD }}</span>
              }
              <i class="bi bi-box-arrow-up-right np-open" aria-hidden="true"></i>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</p-popover>
